// extracted by mini-css-extract-plugin
export default {"contentBody":"ContentBody_contentBody__dDlqe"};